import moment from 'moment';

export const hasActiveDate = (date?: string): date is string =>
  !!date && !moment.utc(date).isSame(moment.utc(0), 'day');
